// A page's root column scrolls at the window's height, so flexbox shrinks its sections to fit. A section that
// clips its own art (overflow hidden) may then shrink below its content and cut off its heading and buttons,
// so every element directly in a vertical page root keeps its height and the root scrolls instead.
export const KEEPS_ITS_HEIGHT_CLASS = "element-keeps-its-height";

const HORIZONTAL_TYPES = new Set(["HorizontalContainerWrapper", "HorizontalContainer"]);

export function holdsPageSections({ elementId, rootElementId, elementType }) {
  return String(elementId) === String(rootElementId) && !HORIZONTAL_TYPES.has(elementType);
}

// A child set to fill the window (an app-like page whose content area scrolls inside itself) still fits the
// window; only sections that hug their content or have a fixed height are kept from shrinking.
export function keepsItsHeight({ inPageRoot, layoutHeight }) {
  return inPageRoot && !/fill/i.test(String(layoutHeight ?? ""));
}
